import { render, staticRenderFns } from "./basePage.vue?vue&type=template&id=6209ef56"
import script from "./basePage.vue?vue&type=script&lang=js"
export * from "./basePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports